module.exports = __webpack_public_path__ + "static/media/indent.6eb9ce29.svg";